import { useQueryWithUserId } from '@northladder/services';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';

/**
 * This is to track the device categories from the backend.
 */
const DEVICE_CATEGORIES_KEY = 'device-categories-key';

export interface IUseDeviceCategoriesQueryPayload {
  isPlatformUser: boolean;
}

/**
 * This hook fetches a list of device category id and name.
 * These category ids and names are mapped in the step-3 `TradeInDeviceDropdown`
 * component.
 */
export const useDeviceCategoriesQuery = (
  options?: IUseDeviceCategoriesQueryPayload
) => {
  const { isPlatformUser = false } = options || {};

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [DEVICE_CATEGORIES_KEY, isPlatformUser],
    networkMode: 'always',
    queryFn: () =>
      USER_REGISTRATION_API.fetchTradeInDeviceCategories(isPlatformUser),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
